export const en = {
	applyAll: "Apply all",
	exportData: "Export data",
	importData: "Import data",
	resetChanges: "Reset changes",
	autoLayout: "Auto layout",

	arrange: "Arrange",
	position: "Position",
	size: "Size",
	color: "Color",
	title: "Title",
	text: "Text",
	image: "Image",
	fill: "Fill",
	textProps: "Text style",
	textPosition: "Text position",
	stroke: "Stroke",
	gridStep: "Grid step",

	headerText: "Header text",
	headerFill: "Header fill",
	headerStyle: "Header style",
	headerPosition: "Header position",
	headerEnable: "Header",
	subHeaderRowsEnable: "Subheader rows",
	subHeaderColsEnable: "Subheader cols",

	positionOptions: {
		top: "top",
		bottom: "bottom",
		left: "left",
		right: "right",
	},
	switchOptions: {
		on: "on",
		off: "off",
	},

	shapeSections: "Shapes",
	groupSections: "Groups",
	swimlaneSections: "Swimlanes",

	imageUpload: "Click to upload",
	emptyState: "Select a shape or a connector",

	menuDeleteRow: "Delete row",
	menuDeleteCol: "Delete column",
	menuMoveColumnRight: "Move column right",
	menuMoveColumnLeft: "Move column left",
	menuMoveRowUp: "Move row up",
	menuMoveRowDown: "Move row down",
	menuAddRowUp: "Add row up",
	menuAddRowDown: "Add row down",
	menuAddColumnRight: "Add column right",
	menuAddColumnLeft: "Add column left",

	menuDelete: "Delete",
	menuAddPartner: "Add partner",
	menuAddAssistant: "Add assistant",
	menuAlignChildrenVertically: "Align children vertically",
	menuAlignChildrenHorizontally: "Align children horizontally",
};

export default en;
